import apiClient from "../../.../../../http-common";
import authHeader from "../../../authentication/authservices/auth-header";

export const getABGAnalysisVisitDateList = (admissionId) => {
  return apiClient.get(`/abg/datesInfo/${admissionId}`, {
    headers: authHeader(),
  });
};


export const getABGAnalysisListByVisitDate = (postObj) => {
  return apiClient.post(`/abg/abgresult`,postObj, {
    headers: authHeader(),
  });
};
